import { Component, OnInit } from '@angular/core';

declare var DobryKantor: any;

@Component({
    selector: 'dk-user-data-status',
    template: require('./user-data-status.html'),
    inputs: ['isActive','personalData']
})

export class UserDataStatusComponent implements OnInit {
    public isActive: boolean = true;
    public cantorName: string;
    public version: string;

    constructor() {

    }

    public ngOnInit() {
        this.cantorName = DobryKantor.params.cantor.name;
        this.version = DobryKantor.params.cantor.version;
    }
}